import api from '../base';

const CAREERS = '/careers';
const N_CAREERS = 20;

export default {
  getCareers() {
    return api.get(`${CAREERS}?take=${N_CAREERS}`);
  },

  getCareerById(careerId) {
    return api.get(`${CAREERS}/${careerId}`);
  }
};



// WEBPACK FOOTER //
// src/services/careers/service.js